const ANONYMOUS_AUTH_PREFIXES = [
  "/api/auth/register/",
  "/api/auth/login/",
  "/api/auth/password/reset/",
  "/api/auth/passkeys/login/",
];

const UNCLEARED_SESSION_RECOVERY_PATHS = new Set([
  "/api/auth/me",
  "/api/auth/logout",
  "/api/auth/otp/send",
  "/api/auth/otp/verify",
  "/api/auth/otp/verify-link",
]);

/**
 * A cached or incomplete session may send its bearer only to narrowly scoped
 * recovery endpoints until the server positively clears this installation.
 */
export function shouldAttachAuthBearer(path, session) {
  if (!session?.accessToken) return false;
  const normalizedPath = String(path || "").split(/[?#]/, 1)[0];
  if (ANONYMOUS_AUTH_PREFIXES.some((prefix) => normalizedPath.startsWith(prefix))) {
    return false;
  }
  if (session.contactVerificationDeviceCleared === true) return true;
  return UNCLEARED_SESSION_RECOVERY_PATHS.has(normalizedPath);
}
